module.exports = __webpack_public_path__ + "static/media/glossary-icon.891284cb.svg";